// C:\xampp\htdocs\sait\client\src\http\index.js
import axios from "axios"; // Возможно, понадобится для проверки токена, но не обязательно для интерцептора

const $host = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL
});

const $authHost = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL
});

// --- Переменные для управления очередью запросов при обновлении токена ---
let isRefreshing = false; // Флаг, указывающий, идет ли сейчас процесс обновления токена
let failedQueue = [];     // Очередь запросов, которые "провалились" из-за истекшего токена

// Функция для обработки очереди провалившихся запросов
const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error); // Если обновление токена не удалось, отклоняем провалившиеся запросы
        } else {
            prom.resolve(token); // Если успешно, разрешаем провалившиеся запросы с новым токеном
        }
    });
    failedQueue = []; // Очищаем очередь
};

$host.interceptors.request.use(config => {
    const token = localStorage.getItem('token');

    // Если токен есть, прикрепляем его к запросу.
    // ЭТО ПОЗВОЛИТ СЕРВЕРУ ПРОЧИТАТЬ req.user, ЕСЛИ ПОЛЬЗОВАТЕЛЬ АВТОРИЗОВАН.
    if (token && token !== 'null' && token !== 'undefined') {
        config.headers.authorization = `Bearer ${token}`;
    }
    // Если токена нет, просто продолжаем запрос БЕЗ ЗАГОЛОВКА Authorization.

    return config;
});

$authHost.interceptors.request.use(config => {
    const token = localStorage.getItem('token');

    if (token && token !== 'null' && token !== 'undefined') {
        config.headers.authorization = `Bearer ${token}`;
    } else {
        // 🔹 ВАЖНО: полностью удаляем заголовок, если токена нет
        delete config.headers.authorization;
    }

    return config;
});

$authHost.interceptors.response.use(
    (response) => response, // Если ответ успешный, просто возвращаем его
    async (error) => {
        const originalRequest = error.config; // Сохраняем оригинальный запрос
        const status = error.response?.status; // Получаем статус ошибки

        // Проверяем, является ли ошибка 401 Unauthorized И не является ли это повторным запросом
        if (status === 401 && originalRequest && !originalRequest._isRetry) {
            originalRequest._isRetry = true; // Помечаем запрос, чтобы избежать бесконечного цикла

            if (isRefreshing) {
                // Если процесс обновления токена уже идет,
                // ставим текущий провалившийся запрос в очередь
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then(token => {
                        // Когда токен обновится, обновляем заголовок авторизации и повторяем запрос
                        originalRequest.headers['authorization'] = `Bearer ${token}`;
                        return $authHost(originalRequest);
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    });
            }

            isRefreshing = true;

            return new Promise(async (resolve, reject) => {
                try {

                    const response = await $host.get('api/user/refresh');

                    const newAccessToken = response.data.accessToken;
                    localStorage.setItem('token', newAccessToken);

                    originalRequest.headers['authorization'] = `Bearer ${newAccessToken}`;
                    processQueue(null, newAccessToken);
                    resolve($authHost(originalRequest));
                } catch (refreshError) {
                    processQueue(refreshError, null); // Отклоняем все запросы в очереди, если обновление не удалось

                    localStorage.removeItem('token');
                    document.cookie = 'refreshToken=; Max-Age=0; path=/';
                    reject(refreshError);
                } finally {
                    isRefreshing = false;
                }
            });
        }

        // Для всех других ошибок или если 401 не связан с токеном, просто отклоняем промис
        return Promise.reject(error);
    }
);

export {
    $host,
    $authHost
};